import { clsx } from "clsx";
import { Info, OctagonAlert, TriangleAlert } from "lucide-react";

import type { NoteSeverity } from "../../types.ts";
import { SEVERITY_LABELS } from "../../utils/severity.ts";

const ICONS = {
	info: Info,
	warning: TriangleAlert,
	critical: OctagonAlert,
};

export function SeverityIcon({
	severity,
	className,
	labelled = false,
}: {
	severity: NoteSeverity;
	className?: string;
	labelled?: boolean;
}) {
	const Icon = ICONS[severity];
	return (
		<Icon
			className={clsx("severity-icon", className)}
			data-severity={severity}
			aria-hidden={!labelled}
			aria-label={labelled ? SEVERITY_LABELS[severity] : undefined}
			role={labelled ? "img" : undefined}
		/>
	);
}
